const ldTestValidation = () => {
    const quizForm = document.querySelector('.wpProQuiz_content');
    if (!quizForm) return;


    const clearErrors = () => {
        const errorContainers = quizForm.querySelectorAll('.continue_test_error');
        errorContainers.forEach(container => {
            container.textContent = '';
        });
    };


    ['click', 'mousedown', 'touchstart', 'keydown', 'focus'].forEach(eventType => {
        quizForm.addEventListener(eventType, clearErrors, true);
    });

    const originalAlert = window.alert;
    window.alert = function(message) {
        if (message && message.includes('You must answer')) {
            const activeButton = document.activeElement;
            if (activeButton && activeButton.classList.contains('wpProQuiz_QuestionButton')) {

                let errorContainer = activeButton.previousElementSibling;
                while (errorContainer) {
                    if (errorContainer.classList.contains('continue_test_error')) break;
                    errorContainer = errorContainer.previousElementSibling;
                }

                if (errorContainer) {
                    errorContainer.classList.add('error-alert');
                    errorContainer.innerHTML = `<span>${rcTranslate.continue_test_error}</span>`;
                    errorContainer.style.marginBottom = '10px';
                }
            }
            return;
        }
        originalAlert(message);
    };
};

export default ldTestValidation;
